import { createFileRoute } from '@tanstack/react-router'
import ProductionPlans from 'Admin/components/productionPlans/ProductionPlans'

import { Guard } from '../-guard'

export const Route = createFileRoute('/admin/production-plans')({
    component: () => (
        <Guard claims={['opus_user']}>
            <ProductionPlans />
        </Guard>
    ),
})
